<template lang="html">
  <div class="content-item-message">
    <img class="avater" v-if="isActual" v-lazy="`http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E7%A5%9E%E7%A7%98%E5%A4%B4%E5%83%8F.png?x-oss-process=image/resize,m_fill,w_72,h_72`" />
    <img class="avater" v-else v-lazy="`${avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"/>
    <div class="content-item-body" @click="goCreate">
      <div class="content-item" >
        <div>
            <h2 v-if="!isActual">{{nickName}}</h2>
            <h2 v-else-if="isActual && isOfficial">{{officialName}}</h2>
            <h5 class="time"><span>{{getShowTime(crateTime)}}</span> <span v-if="(users && users.id === user__id)" class="delete" @click.stop="deleteMessage">删除</span></h5>
        </div>
        <!-- <div class="content-item-right" @click.stop="thumbsUp">
            <img v-if="isUp" src="../../../assets/images/dynamic/thumbs-up-black.svg" />
            <img v-else src="../../../assets/images/dynamic/thumbs-up-white.svg" />
            <span>{{upCount ? upCount : ''}}</span>
          </div> -->
          <ThumbUpItem @click="thumbsUp" v-bind="getThumbUp" />
      </div>
      <span v-if="parentCommentId" class="desc"><span class="parent"></span>{{content}}</span>
      <span v-else class="desc">{{content}}</span>
    </div>
  </div>
</template>
<script>
import { getBeforeTimeStr } from '../../../utils/date'
import { post, _delete } from '../../../utils/request'
import { get } from '../../../utils/token'
import ThumbUpItem from '../../../components/thunmbUpItem'
import { Toast } from 'vant'
export default {
  components: {
    ThumbUpItem
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    officialName: {
      type: String,
      default: ''
    },
    isOfficial: {
      type: Boolean,
      default: false
    },
    isActual: {
      type: Boolean,
      default: false
    },
    parentCommentId: {
      type: Number,
      default: 0
    },
    parentNickName: {
      type: String,
      default: ''
    },
    nickName: {
      type: String,
      default: ''
    },
    user__id: {
      type: Number,
      default: 0
    },
    crateTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    dissId: {
      type: Number,
      default: 0
    },
    avatar: {
      type: String,
      default: ''
    },
    upCount: {
      type: Number,
      default: 0
    },
    isUp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      users: get('user')
    }
  },
  methods: {
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    deleteMessage () {
      const user = get('user')
      const promise = _delete({
        url: '/diss/comment',
        data: {
          userId: user.id,
          commentId: this.id
        }
      })
      promise.then(res => {
        const { data: { message } } = res
        this.$emit('deleteMessage', this.id)
        Toast.success(message)
      })
    },
    goCreate () {
      this.$router.push(`/exerland/makeComplaintsCreate?dissId=${this.dissId}&pid=${this.id}&parentNickName=${this.nickName}`)
    },
    thumbsUp (callback) {
      const promsie = post({
        url: `/diss/isUpComment/${this.id}/${get('user').id}`,
        data: {
          isUp: !this.isUp
        }
      })
      promsie.then(res => {
        const { status } = res
        if (Object.is(status, 200)) {
          if (callback) {
            callback()
          }
          this.$emit('thumbsUp')
        }
      })
    }
  },
  computed: {
    getThumbUp () {
      return {
        idProp: this.isUp,
        url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        count: this.upCount,
        label: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content-item-message {
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  .avater {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .content-item-body {
    cursor: pointer;
    .content-item {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      h2 {
        font-size: 16px;
        font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      .content-item-right {
          display: flex;
          align-items: center;
          margin-right: 20px;
          img {
            width: 15px;
            height: 15px;
            margin-right: 8px;
          }
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
    }
    .time {
      font-size: 13px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      display: flex;
      align-items: center;
      .delete {
          display: inline-block;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,107,148,1);
          margin-left: 16px;
        }
    }
    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      width: 79.2vw;
      // text-overflow: ellipsis;
      // overflow: hidden;
      display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .parent {
      color: #888888;
    }
    .content-item-imgs {
      margin-bottom: 11px;
      img {
        width: 92px;
        height: 92px;
        margin-right: 4px;
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      align-items: center;
    }
  }
}
</style>
